export default { sha: '818310d5a7f94fa2ba73d8afd3dd368a433ba992', buildNumber: 'undefined' }
